(() => {
  const key = 'cls-language-choice-v1';
  const welcome = document.getElementById('ClsLanguageWelcome');
  const remember = value => {
    try { localStorage.setItem(key, value); } catch (_) {}
    if (welcome) welcome.hidden = true;
  };
  document.querySelectorAll('.cls-language-form').forEach(form => {
    form.addEventListener('submit', event => {
      const selected = event.submitter?.value;
      if (selected) remember(selected);
    });
  });
  if (!welcome || welcome.dataset.designMode === 'true') return;
  let seen = false;
  try { seen = Boolean(localStorage.getItem(key)); } catch (_) {}
  if (!seen && welcome.dataset.locale === 'en') welcome.hidden = false;
  if (welcome.dataset.locale !== 'en') remember(welcome.dataset.locale);
  welcome.querySelector('[data-dismiss-language]')?.addEventListener('click', () => remember(welcome.dataset.locale));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !welcome.hidden) remember(welcome.dataset.locale);
  });
})();
